import type { CrossModelParameterSpecification } from "@mm/api-layers.meteomatics.com";
import { STATION_MODEL_ID, type StationModelId } from "./staticStationModels";

export const aargauRoadStationsParams: CrossModelParameterSpecification[] = [
  {
    name: "dew_point",
    description_de: "Taupunkttemperatur",
    description_en: "Dew point temperature",
    description_fr: "Point de rosée",
    default_values: {
      unit: undefined,
      level: undefined,
      interval: undefined,
    },
    flags: [],
    layers: [
      {
        unit: ["C", "K", "F"],
        level: ["2m"],
        format: "dew_point_\u003Clevel\u003E:\u003Cunit\u003E",
      },
    ],
    available_models: [STATION_MODEL_ID.AARGAU],
  },
  {
    name: "freezing_point",
    description_de: "Gefrierpunkt",
    description_en: "Freezing point",
    description_fr: "Point de congélation",
    default_values: {
      unit: undefined,
      level: undefined,
      interval: undefined,
    },
    flags: [],
    layers: [
      {
        unit: ["C"],
        format: "freezing_point:\u003Cunit\u003E",
      },
    ],
    available_models: [STATION_MODEL_ID.AARGAU],
  },
  {
    name: "precip_type",
    description_de: "Niederschlagsart",
    description_en: "Precipitation type",
    description_fr: "Type de précipitation",
    default_values: {
      unit: undefined,
      level: undefined,
      interval: undefined,
    },
    flags: [],
    layers: [
      {
        unit: ["idx"],
        format: "precip_type:\u003Cunit\u003E",
      },
    ],
    available_models: [STATION_MODEL_ID.AARGAU],
  },
  {
    name: "relative_humidity",
    description_de: "Relative Feuchtigkeit",
    description_en: "Relative humidity",
    description_fr: "Humidité relative",
    default_values: {
      unit: undefined,
      level: undefined,
      interval: undefined,
    },
    flags: [],
    layers: [
      {
        unit: ["p"],
        level: ["2m"],
        format: "relative_humidity_\u003Clevel\u003E:\u003Cunit\u003E",
      },
    ],
    available_models: [STATION_MODEL_ID.AARGAU],
  },
  {
    name: "road_condition",
    description_de: "Straßenzustand",
    description_en: "Road condition",
    description_fr: "Etat de la route",
    default_values: {
      unit: undefined,
      level: undefined,
      interval: undefined,
    },
    flags: [],
    layers: [
      {
        unit: ["idx"],
        format: "road_condition:\u003Cunit\u003E",
      },
    ],
    available_models: [STATION_MODEL_ID.AARGAU],
  },
  {
    name: "salt_concentration",
    description_de: "Salz Konzentration",
    description_en: "Salt concentration",
    description_fr: "Concentration en sel",
    default_values: {
      unit: undefined,
      level: undefined,
      interval: undefined,
    },
    flags: [],
    layers: [
      {
        unit: ["p"],
        format: "salt_concentration:\u003Cunit\u003E",
      },
    ],
    available_models: [STATION_MODEL_ID.AARGAU],
  },
  {
    name: "sfc_pressure",
    description_de: "Druck auf Bodenhöhe (sfc pressure)",
    description_en: "Surface pressure (sfc pressure)",
    description_fr: "Pression à la surface",
    default_values: {
      unit: "hPa",
      level: undefined,
      interval: undefined,
    },
    flags: [],
    layers: [
      {
        unit: ["hPa"],
        format: "sfc_pressure:\u003Cunit\u003E",
      },
    ],
    available_models: [STATION_MODEL_ID.AARGAU],
  },
  {
    name: "t",
    description_de: "Temperatur",
    description_en: "Temperature",
    description_fr: "Température",
    default_values: {
      unit: undefined,
      level: "2m",
      interval: undefined,
    },
    flags: [],
    layers: [
      {
        unit: ["C", "K", "F"],
        level: ["-30cm", "-5cm", "2m"],
        format: "t_\u003Clevel\u003E:\u003Cunit\u003E",
      },
    ],
    available_models: [STATION_MODEL_ID.AARGAU],
  },
  {
    name: "t_road",
    description_de: "Straßentemperatur",
    description_en: "Road temperature",
    description_fr: "Température de la route",
    default_values: {
      unit: undefined,
      level: undefined,
      interval: undefined,
    },
    flags: [],
    layers: [
      {
        unit: ["C", "K", "F"],
        format: "t_road:\u003Cunit\u003E",
      },
    ],
    available_models: [STATION_MODEL_ID.AARGAU],
  },
  {
    name: "water_film_height",
    description_de: "Wasserfilm",
    description_en: "Road water film height",
    description_fr: "Hauteur du film d'eau sur la route",
    default_values: {
      unit: undefined,
      level: undefined,
      interval: undefined,
    },
    flags: [],
    layers: [
      {
        unit: ["mm"],
        format: "water_film_height:\u003Cunit\u003E",
      },
    ],
    available_models: [STATION_MODEL_ID.AARGAU],
  },
  {
    name: "wind_dir",
    description_de: "Windrichtung",
    description_en: "Wind direction",
    description_fr: "Direction du vent",
    default_values: {
      unit: undefined,
      level: "10m",
      interval: undefined,
    },
    flags: [],
    layers: [
      {
        unit: ["d"],
        level: ["10m"],
        format: "wind_dir_\u003Clevel\u003E:\u003Cunit\u003E",
      },
    ],
    available_models: [STATION_MODEL_ID.AARGAU],
  },
  {
    name: "wind_speed",
    description_de: "Windgeschwindigkeit",
    description_en: "Wind speed",
    description_fr: "Vitesse du vent",
    default_values: {
      unit: "ms",
      level: "10m",
      interval: undefined,
    },
    flags: [],
    layers: [
      {
        unit: ["kmh", "mph", "ms", "kn", "bft"],
        level: ["10m"],
        format: "wind_speed_\u003Clevel\u003E:\u003Cunit\u003E",
      },
    ],
    available_models: [STATION_MODEL_ID.AARGAU],
  },
] as unknown as CrossModelParameterSpecification[];

export const nationalstrassenRoadStationsParams: CrossModelParameterSpecification[] = [
  {
    name: "dew_point",
    description_de: "Taupunkttemperatur",
    description_en: "Dew point temperature",
    description_fr: "Point de rosée",
    default_values: {
      unit: undefined,
      level: undefined,
      interval: undefined,
    },
    flags: [],
    layers: [
      {
        unit: ["C", "K", "F"],
        level: ["2m"],
        format: "dew_point_\u003Clevel\u003E:\u003Cunit\u003E",
      },
    ],
    available_models: [STATION_MODEL_ID.NATIONALSTRASSEN],
  },
  {
    name: "precip",
    description_de: "Niederschlagsmenge",
    description_en: "Amount of precipitation",
    description_fr: "Précipitations",
    default_values: {
      unit: "mm",
      level: undefined,
      interval: undefined,
    },
    flags: [],
    layers: [
      {
        unit: ["mm"],
        interval: ["1h"],
        format: "precip_\u003Cinterval\u003E:\u003Cunit\u003E",
      },
    ],
    available_models: [STATION_MODEL_ID.NATIONALSTRASSEN],
  },
  {
    name: "precip_type",
    description_de: "Niederschlagsart",
    description_en: "Precipitation type",
    description_fr: "Type de précipitation",
    default_values: {
      unit: undefined,
      level: undefined,
      interval: undefined,
    },
    flags: [],
    layers: [
      {
        unit: ["idx"],
        format: "precip_type:\u003Cunit\u003E",
      },
    ],
    available_models: [STATION_MODEL_ID.NATIONALSTRASSEN],
  },
  {
    name: "relative_humidity",
    description_de: "Relative Feuchtigkeit",
    description_en: "Relative humidity",
    description_fr: "Humidité relative",
    default_values: {
      unit: undefined,
      level: undefined,
      interval: undefined,
    },
    flags: [],
    layers: [
      {
        unit: ["p"],
        level: ["2m"],
        format: "relative_humidity_\u003Clevel\u003E:\u003Cunit\u003E",
      },
    ],
    available_models: [STATION_MODEL_ID.NATIONALSTRASSEN],
  },
  {
    name: "road_condition",
    description_de: "Straßenzustand",
    description_en: "Road condition",
    description_fr: "Etat de la route",
    default_values: {
      unit: undefined,
      level: undefined,
      interval: undefined,
    },
    flags: [],
    layers: [
      {
        unit: ["idx"],
        format: "road_condition:\u003Cunit\u003E",
      },
    ],
    available_models: [STATION_MODEL_ID.NATIONALSTRASSEN],
  },
  {
    name: "road_ice_thickness",
    description_de: "Eisdicke auf der Strasse ",
    description_en: "Road ice thickness",
    description_fr: "Épaisseur de la glace sur la route",
    default_values: {
      unit: "mm",
      level: undefined,
      interval: undefined,
    },
    flags: [],
    layers: [
      {
        unit: ["mm"],
        format: "road_ice_thickness:\u003Cunit\u003E",
      },
    ],
    available_models: [STATION_MODEL_ID.NATIONALSTRASSEN],
  },
  {
    name: "snow_depth",
    description_de: "Schneetiefe",
    description_en: "Snow depth",
    description_fr: "Hauteur de neige",
    default_values: {
      unit: "cm",
      level: undefined,
      interval: undefined,
    },
    flags: [],
    layers: [
      {
        unit: ["cm", "m"],
        format: "snow_depth:\u003Cunit\u003E",
      },
    ],
    available_models: [STATION_MODEL_ID.NATIONALSTRASSEN],
  },
  {
    name: "soil_moisture_index",
    description_de: "Bodenfeuchteindex",
    description_en: "Soil moisture index",
    description_fr: "Humidité index des sols",
    default_values: {
      unit: undefined,
      level: undefined,
      interval: undefined,
    },
    flags: [],
    layers: [
      {
        unit: ["idx"],
        level: ["-5cm"],
        format: "soil_moisture_index_\u003Clevel\u003E:\u003Cunit\u003E",
      },
    ],
    available_models: [STATION_MODEL_ID.NATIONALSTRASSEN],
  },
  {
    name: "t",
    description_de: "Temperatur",
    description_en: "Temperature",
    description_fr: "Température",
    default_values: {
      unit: undefined,
      level: "2m",
      interval: undefined,
    },
    flags: [],
    layers: [
      {
        unit: ["C", "K", "F"],
        level: ["-30cm", "-7cm", "2m"],
        format: "t_\u003Clevel\u003E:\u003Cunit\u003E",
      },
    ],
    available_models: [STATION_MODEL_ID.NATIONALSTRASSEN],
  },
  {
    name: "t_road",
    description_de: "Straßentemperatur",
    description_en: "Road temperature",
    description_fr: "Température de la route",
    default_values: {
      unit: undefined,
      level: undefined,
      interval: undefined,
    },
    flags: [],
    layers: [
      {
        unit: ["C", "K", "F"],
        format: "t_road:\u003Cunit\u003E",
      },
    ],
    available_models: [STATION_MODEL_ID.NATIONALSTRASSEN],
  },
  {
    name: "visibility",
    description_de: "Sichtweite",
    description_en: "Visibility",
    description_fr: "Visibilité",
    default_values: {
      unit: "km",
      level: undefined,
      interval: undefined,
    },
    flags: [],
    layers: [
      {
        unit: ["km", "m"],
        format: "visibility:\u003Cunit\u003E",
      },
    ],
    available_models: [STATION_MODEL_ID.NATIONALSTRASSEN],
  },
  {
    name: "water_film_height",
    description_de: "Wasserfilm",
    description_en: "Road water film height",
    description_fr: "Hauteur du film d'eau sur la route",
    default_values: {
      unit: undefined,
      level: undefined,
      interval: undefined,
    },
    flags: [],
    layers: [
      {
        unit: ["mm"],
        format: "water_film_height:\u003Cunit\u003E",
      },
    ],
    available_models: [STATION_MODEL_ID.NATIONALSTRASSEN],
  },
  {
    name: "wind_dir",
    description_de: "Windrichtung",
    description_en: "Wind direction",
    description_fr: "Direction du vent",
    default_values: {
      unit: undefined,
      level: "10m",
      interval: undefined,
    },
    flags: [],
    layers: [
      {
        unit: ["d"],
        level: ["10m"],
        format: "wind_dir_\u003Clevel\u003E:\u003Cunit\u003E",
      },
    ],
    available_models: [STATION_MODEL_ID.NATIONALSTRASSEN],
  },
  {
    name: "wind_speed",
    description_de: "Windgeschwindigkeit",
    description_en: "Wind speed",
    description_fr: "Vitesse du vent",
    default_values: {
      unit: "ms",
      level: "10m",
      interval: undefined,
    },
    flags: [],
    layers: [
      {
        unit: ["kmh", "mph", "ms", "kn", "bft"],
        level: ["10m"],
        format: "wind_speed_\u003Clevel\u003E:\u003Cunit\u003E",
      },
    ],
    available_models: [STATION_MODEL_ID.NATIONALSTRASSEN],
  },
] as unknown as CrossModelParameterSpecification[];

export const zentrasRoadStationsParams: CrossModelParameterSpecification[] = [
  {
    name: "dew_point",
    description_de: "Taupunkttemperatur",
    description_en: "Dew point temperature",
    description_fr: "Point de rosée",
    default_values: {
      unit: undefined,
      level: undefined,
      interval: undefined,
    },
    flags: [],
    layers: [
      {
        unit: ["C", "K", "F"],
        level: ["2m"],
        format: "dew_point_\u003Clevel\u003E:\u003Cunit\u003E",
      },
    ],
    available_models: [STATION_MODEL_ID.ZENTRAS],
  },
  {
    name: "precip",
    description_de: "Niederschlagsmenge",
    description_en: "Amount of precipitation",
    description_fr: "Précipitations",
    default_values: {
      unit: "mm",
      level: undefined,
      interval: undefined,
    },
    flags: [],
    layers: [
      {
        unit: ["mm"],
        interval: ["1h"],
        format: "precip_\u003Cinterval\u003E:\u003Cunit\u003E",
      },
    ],
    available_models: [STATION_MODEL_ID.ZENTRAS],
  },
  {
    name: "precip_type",
    description_de: "Niederschlagsart",
    description_en: "Precipitation type",
    description_fr: "Type de précipitation",
    default_values: {
      unit: undefined,
      level: undefined,
      interval: undefined,
    },
    flags: [],
    layers: [
      {
        unit: ["idx"],
        format: "precip_type:\u003Cunit\u003E",
      },
    ],
    available_models: [STATION_MODEL_ID.ZENTRAS],
  },
  {
    name: "road_condition",
    description_de: "Straßenzustand",
    description_en: "Road condition",
    description_fr: "Etat de la route",
    default_values: {
      unit: undefined,
      level: undefined,
      interval: undefined,
    },
    flags: [],
    layers: [
      {
        unit: ["idx"],
        format: "road_condition:\u003Cunit\u003E",
      },
    ],
    available_models: [STATION_MODEL_ID.ZENTRAS],
  },
  {
    name: "snow_depth",
    description_de: "Schneetiefe",
    description_en: "Snow depth",
    description_fr: "Hauteur de neige",
    default_values: {
      unit: "cm",
      level: undefined,
      interval: undefined,
    },
    flags: [],
    layers: [
      {
        unit: ["cm", "m", "mm"],
        format: "snow_depth:\u003Cunit\u003E",
      },
    ],
    available_models: [STATION_MODEL_ID.ZENTRAS],
  },
  {
    name: "soil_moisture_index",
    description_de: "Bodenfeuchteindex",
    description_en: "Soil moisture index",
    description_fr: "Humidité index des sols",
    default_values: {
      unit: undefined,
      level: undefined,
      interval: undefined,
    },
    flags: [],
    layers: [
      {
        unit: ["idx"],
        level: ["-5cm"],
        format: "soil_moisture_index_\u003Clevel\u003E:\u003Cunit\u003E",
      },
    ],
    available_models: [STATION_MODEL_ID.ZENTRAS],
  },
  {
    name: "t",
    description_de: "Temperatur",
    description_en: "Temperature",
    description_fr: "Température",
    default_values: {
      unit: undefined,
      level: "2m",
      interval: undefined,
    },
    flags: [],
    layers: [
      {
        unit: ["C", "K", "F"],
        level: ["-7cm", "2m"],
        format: "t_\u003Clevel\u003E:\u003Cunit\u003E",
      },
    ],
    available_models: [STATION_MODEL_ID.ZENTRAS],
  },
  {
    name: "t_road",
    description_de: "Straßentemperatur",
    description_en: "Road temperature",
    description_fr: "Température de la route",
    default_values: {
      unit: undefined,
      level: undefined,
      interval: undefined,
    },
    flags: [],
    layers: [
      {
        unit: ["C", "K", "F"],
        format: "t_road:\u003Cunit\u003E",
      },
    ],
    available_models: [STATION_MODEL_ID.ZENTRAS],
  },
  {
    name: "water_film_height",
    description_de: "Wasserfilm",
    description_en: "Road water film height",
    description_fr: "Hauteur du film d'eau sur la route",
    default_values: {
      unit: undefined,
      level: undefined,
      interval: undefined,
    },
    flags: [],
    layers: [
      {
        unit: ["mm"],
        format: "water_film_height:\u003Cunit\u003E",
      },
    ],
    available_models: [STATION_MODEL_ID.ZENTRAS],
  },
  {
    name: "wind_dir",
    description_de: "Windrichtung",
    description_en: "Wind direction",
    description_fr: "Direction du vent",
    default_values: {
      unit: undefined,
      level: "10m",
      interval: undefined,
    },
    flags: [],
    layers: [
      {
        unit: ["d"],
        level: ["10m"],
        format: "wind_dir_\u003Clevel\u003E:\u003Cunit\u003E",
      },
    ],
    available_models: [STATION_MODEL_ID.ZENTRAS],
  },
  {
    name: "visibility",
    description_de: "Sichtweite",
    description_en: "Visibility",
    description_fr: "Visibilité",
    default_values: {
      unit: "km",
      level: undefined,
      interval: undefined,
    },
    flags: [],
    layers: [
      {
        unit: ["km", "m"],
        format: "visibility:\u003Cunit\u003E",
      },
    ],
    available_models: [STATION_MODEL_ID.ZENTRAS],
  },
  {
    name: "wind_speed",
    description_de: "Windgeschwindigkeit",
    description_en: "Wind speed",
    description_fr: "Vitesse du vent",
    default_values: {
      unit: "ms",
      level: "10m",
      interval: undefined,
    },
    flags: [],
    layers: [
      {
        unit: ["kmh", "mph", "ms", "kn", "bft"],
        level: ["10m"],
        format: "wind_speed_\u003Clevel\u003E:\u003Cunit\u003E",
      },
    ],
    available_models: [STATION_MODEL_ID.ZENTRAS],
  },
] as unknown as CrossModelParameterSpecification[];

/**
 * Shared parameter set for road station models that currently expose
 * an identical set of derived variables.
 */
export const gotthardNsnwRoadStationsParamsCreator: (sourceId: StationModelId) => CrossModelParameterSpecification[] = (
  sourceId,
) => {
  return [
    {
      name: "dew_point",
      description_de: "Taupunkttemperatur",
      description_en: "Dew point temperature",
      description_fr: "Point de rosée",
      default_values: { unit: undefined, level: undefined, interval: undefined },
      flags: [],
      layers: [{ unit: ["C", "K", "F"], level: ["2m"], format: "dew_point_<level>:<unit>" }],
      available_models: [sourceId],
    },
    {
      name: "msl_pressure",
      description_de: "Luftdruck auf Meereshöhe (MSL pressure)",
      description_en: "Mean sea level pressure (MSL pressure)",
      description_fr: "Pression au niveau de la mer",
      default_values: { unit: "hPa", level: undefined, interval: undefined },
      flags: [],
      layers: [{ unit: ["hPa"], format: "msl_pressure:<unit>" }],
      available_models: [sourceId],
    },
    {
      name: "precip",
      description_de: "Niederschlagsmenge",
      description_en: "Amount of precipitation",
      description_fr: "Précipitations",
      default_values: { unit: "mm", level: undefined, interval: undefined },
      flags: [],
      layers: [{ unit: ["mm"], interval: ["1h"], format: "precip_<interval>:<unit>" }],
      available_models: [sourceId],
    },
    {
      name: "relative_humidity",
      description_de: "Relative Feuchtigkeit",
      description_en: "Relative humidity",
      description_fr: "Humidité relative",
      default_values: { unit: undefined, level: undefined, interval: undefined },
      flags: [],
      layers: [{ unit: ["p"], level: ["2m"], format: "relative_humidity_<level>:<unit>" }],
      available_models: [sourceId],
    },
    {
      name: "road_condition",
      description_de: "Straßenzustand",
      description_en: "Road condition",
      description_fr: "Etat de la route",
      default_values: { unit: undefined, level: undefined, interval: undefined },
      flags: [],
      layers: [{ unit: ["idx"], format: "road_condition:<unit>" }],
      available_models: [sourceId],
    },
    {
      name: "t",
      description_de: "Temperatur",
      description_en: "Temperature",
      description_fr: "Température",
      default_values: { unit: undefined, level: "2m", interval: undefined },
      flags: [],
      layers: [{ unit: ["C", "K", "F"], level: ["2m"], format: "t_<level>:<unit>" }],
      available_models: [sourceId],
    },
    {
      name: "t_road",
      description_de: "Straßentemperatur",
      description_en: "Road temperature",
      description_fr: "Température de la route",
      default_values: { unit: undefined, level: undefined, interval: undefined },
      flags: [],
      layers: [{ unit: ["C", "K", "F"], format: "t_road:<unit>" }],
      available_models: [sourceId],
    },
    {
      name: "visibility",
      description_de: "Sichtweite",
      description_en: "Visibility",
      description_fr: "Visibilité",
      default_values: { unit: "km", level: undefined, interval: undefined },
      flags: [],
      layers: [{ unit: ["km", "m"], format: "visibility:<unit>" }],
      available_models: [sourceId],
    },
    {
      name: "water_film_height",
      description_de: "Wasserfilm",
      description_en: "Road water film height",
      description_fr: "Hauteur du film d'eau sur la route",
      default_values: { unit: undefined, level: undefined, interval: undefined },
      flags: [],
      layers: [{ unit: ["mm"], format: "water_film_height:<unit>" }],
      available_models: [sourceId],
    },
    {
      name: "wind_dir",
      description_de: "Windrichtung",
      description_en: "Wind direction",
      description_fr: "Direction du vent",
      default_values: { unit: undefined, level: "10m", interval: undefined },
      flags: [],
      layers: [{ unit: ["d"], level: ["10m"], format: "wind_dir_<level>:<unit>" }],
      available_models: [sourceId],
    },
    {
      name: "wind_speed",
      description_de: "Windgeschwindigkeit",
      description_en: "Wind speed",
      description_fr: "Vitesse du vent",
      default_values: { unit: "ms", level: "10m", interval: undefined },
      flags: [],
      layers: [
        {
          unit: ["bft", "kmh", "kn", "mph", "ms"],
          level: ["10m"],
          format: "wind_speed_<level>:<unit>",
        },
      ],
      available_models: [sourceId],
    },
  ] as unknown as CrossModelParameterSpecification[];
};

export const gotthardRoadStationsParams = gotthardNsnwRoadStationsParamsCreator(STATION_MODEL_ID.GOTTHARD);
export const nsnwRoadStationsParams = gotthardNsnwRoadStationsParamsCreator(STATION_MODEL_ID.NSNW);
